import React from 'react'
import styled, { css } from 'styled-components'
import Icon from '../styles/Icon.style'

type Props = {
    value: string
    onChange: (value: string) => void
    options?: {
        border?: boolean
    }
}

const SearchBar = ({ value, onChange, options = {} }: Props): JSX.Element => {
    return (
        <SearchBarContainer {...options}>
            <div className="left-search">
                <Icon className="far fa-search" color="var(--gray-400)" size="13px" />
                <input
                    type="text"
                    placeholder="Search"
                    value={value}
                    onChange={e => onChange?.(e.target.value)}
                    style={{ border: 'none' }}
                />
            </div>
            <button className="clear-button" onClick={() => onChange?.('')}>
                <Icon className="far fa-times" color="var(--gray-400)" />
            </button>
        </SearchBarContainer>
    )
}

export default SearchBar

export const SearchBarContainer = styled.div<Props['options']>`
    ${({ border = true }) =>
        border &&
        css`
            border-radius: 3px;
            border: 1px solid var(--gray-300);
        `}

    padding: 0 8px;

    &,
    .left-search {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    justify-content: space-between;

    .left-search {
        width: 100%;
        gap: 4px;

        input {
            background: transparent;
            border: none;
            outline: none;
            padding: 10px;
            width: 100%;
        }
    }

    .clear-button {
        background-color: transparent;
        border: none;
    }
`
